<template>
  <v-container class="container--fluid text-center">
   <div style="height:350"  v-if="!this.ishavedata">
        <v-progress-circular
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular></div>
       <div v-if="this.ishavedata" id="chart">
          <apexchart
            type="line"
            height="350"
            ref="chart"
            :options="chartOptions"
            :series="seriesnew"
          ></apexchart>
        </div>
  </v-container>
</template>

<script>
//import { bus } from "../../../main";
import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";



Vue.use(VueAxios, axios);
export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
        title: {
            type: String,
            default: null,
        },
         divvalue: {
            type: String,
            default: '',
        },
        
         divvaluelist: []
    },
  data: () => ({
    //for chart
    itemsplottemp: [],
    itemsplot: [],
    seriesnew: [],
    labelnew: [],
    series1: [
      {
        name: "TEAM A",
        type: "bar",
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
      },
      {
        name: "TEAM B",
        type: "line",
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
      },
      {
        name: "TEAM C",
        type: "line",
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39],
      },
    ],
    chartshow: 0,
    chartOptions: {
      chart: {
        height: 350,
        type: "line",
        stacked: false,
      },
      stroke: {
        width: [2, 2, 2],
        curve: "smooth",
      },
      plotOptions: {
        bar: {
          columnWidth: "50%",
        },
      },

      fill: {
        type: "solid",
      },
      labels: [
        "2018-09-01",
        "2018-10-01",
        "2018-11-01",
        "2018-12-01",
        "2019-01-01",
        "2019-02-01",
        "2019-03-01",
        "2019-04-01",
        "2019-05-01",
        "2019-06-01",
        "2019-07-01",
        "2019-08-01",
        "2019-09-01",
        "2019-10-01",
        "2019-11-01",
        "2019-12-01",
        "2020-01-01",
        "2020-02-01",
        "2020-03-01",
        "2020-04-01",
        "2020-05-01",
        "2020-06-01",
        "2020-07-01",
        "2020-08-01",
        "2020-09-01",
        "2020-10-01",
        "2020-11-01",
        "2020-12-01",
        "2021-01-01",
        "2021-02-01",
        "2021-03-01",
        "2021-04-01",
        "2021-05-01",
        "2021-06-01",
        "2021-07-01",
        "2021-08-01",
      ],
      markers: {
        size: 0,
      },
      xaxis: {
        type: "datetime",
      },
      yaxis: {
        title: {
          text: "Points",
        },
        min: 0,
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y) {
            if (typeof y !== "undefined") {
              return y.toFixed(0) + " points";
            }
            return y;
          },
        },
      },
      grid: {
        show: false, // you can either change hear to disable all grids
        xaxis: {
          lines: {
            show: false, //or just here to disable only x axis grids
          },
        },
        yaxis: {
          lines: {
            show: false, //or just here to disable only y axis
          },
        },
      },
    },

    xaxismin: null,
    xaxismax: null,
    //end for chart
    //loading
    ishavedata:false,

    divdata: null,

  }),

  methods: {

    onloadgotchart() {
    
       this.getplot();
   
     
    },
getplot() {
   
    this.ishavedata=false;
    
           this.itemsplot=[];
            this.itemsplot =this.divdata;
            //alert(JSON.stringify( this.itemsplot ));
            this.createchartseries();
             this.ishavedata=true;
    },
  

    getchartseries() {
      var keys = [];
      var tkey = [];
      var datelist = [];
      for (var k1 in this.itemsplot[0]) {
        if (k1 != "t_date") {
          keys.push(k1);
          var obj = new Object();
          obj.name = k1;
          var keysdata = [];
          for (var i = 0; i < this.itemsplot.length; i++) {
            datelist.push(new Date(this.itemsplot[i].t_date).getTime());
            var innerdata = [];
            //innerdata.push(k1);
            // let newval=new Date(this.itemsplot[i].t_date).getTime() + "," + this.itemsplot[i][k1];

            innerdata.push(new Date(this.itemsplot[i].t_date).getTime());
            innerdata.push(this.itemsplot[i][k1]);
            keysdata.push(innerdata);
          }

          obj.data = keysdata;

          tkey.push(obj);
        }
      }
      //this.newseries = tkey;
      this.series = [];
      this.series = tkey;

      let datelistarray = [];
      datelistarray = datelist;
      let maxdate = Math.max.apply(Math, datelistarray);
      let mindate = Math.min.apply(Math, datelistarray);
      this.xaxismin = mindate;
      this.xaxismax = maxdate;
      //alert(mindate);

      this.chartOptions = {
        ...this.chartOptions,
        ...{
         
          xaxis: {
            type: "datetime",
            min: mindate,
            max: maxdate,
            tickAmount: 6,
          },
          annotations: {
            yaxis: [
              {
                y: 0,
                borderColor: "#999",
                label: {
                  show: true,
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#00E396",
                  },
                },
              },
            ],
            xaxis: [
              {
                x: mindate,
                borderColor: "#999",
                yAxisIndex: 0,

                label: {
                  show: true,
                  formatter: function (val) {
                    return "YY-" + val;
                  },
                  text: "",
                  style: {
                    color: "#fff",
                    background: "#775DD0",
                  },
                },
              },
            ],
          },
        },
      };
      this.chartshow = 1;
    },

    createchartseries() {
      this.seriesnew = [];

      //
      let objError = new Object();
      objError.name = "error";
      objError.type = "bar";
      let objErrordata = [];
      for (var k2 = 0; k2 < this.itemsplot.length; k2++) {
        objErrordata.push(this.itemsplot[k2].error);
      }
      objError.data = objErrordata;

      this.seriesnew.push(objError);

      //
      let objPredicted = new Object();
      objPredicted.name = "predicted";
      objPredicted.type = "line";
      let objPredicteddata = [];
      for (var k = 0; k < this.itemsplot.length; k++) {
        objPredicteddata.push(this.itemsplot[k].predicted);
      }
      objPredicted.data = objPredicteddata;

      this.seriesnew.push(objPredicted);

      let objActual = new Object();
      objActual.name = "actual";
      objActual.type = "line";
      let objActualdata = [];
      for (var i = 0; i < this.itemsplot.length; i++) {
        objActualdata.push(this.itemsplot[i].actual);
      }
      objActual.data = objActualdata;

      this.seriesnew.push(objActual);

      //label
      this.labelnew = [];
      // let objlabeldata = [];
      for (var k3 = 0; k3 < this.itemsplot.length; k3++) {
        //objlabeldata.push(this.itemsplot[k3].Period);
        this.labelnew.push(this.itemsplot[k3].period);
      }
      // objError.data = objErrordata;

      //this.labelnew.push(objlabeldata);

      this.chartOptions = {
        labels: this.labelnew,
      };
    },
     Refresh(vardata) {
           // alert(vardata);
            this.divdata=vardata;
            //alert('refreshdwdata');
            this.getplot();
        },
  },
  mounted() {
    //this.getplot();
    //bus.$off("refreshmodelmixchart");
    //bus.$on("refreshmodelmixchart", this.Refresh);
  },
};
</script>

<style scoped>
.title_text {
  font-size: 15px !important;
}

.v-label {
  font-size: 10px !important;
}

.selectedbtn {
  background-color: #0177b2 !important;
  color: white !important;
}

.nonselectedbtn {
  background-color: lightgrey !important;
  color: black !important;
  /* opacity: 40%;*/
}

.errorlog {
  background-color: rgba(255, 0, 0, 0.274);
  color: black;
}

.nonerrorlog {
  background-color: rgba(0, 128, 0, 0.377);
  color: black;
}
</style>
